import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftTicketIndexResponse } from '@/repositories/generated';

const content: GiftTicketIndexResponse[] = [
  {
    giftTicketId: '0055',
    giftTicketName: '青券（中小・一般店のみで利用可）',
    salesManagementCount: 1,
  },
  {
    giftTicketId: '0777',
    giftTicketName: '赤券（大型店・一般店で利用可能）',
    salesManagementCount: 1,
  },
  {
    giftTicketId: '0088',
    giftTicketName: '緑券（一般店で利用可能）',
    salesManagementCount: 0,
  },
];

// ページネーションできるように、券面リストの件数を多めにしておく
const loopContent = new Array<string>(10)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const giftTicket = http.get(
  createMockEndpoint('/gift_ticket'),
  async () => {
    await delay(500);
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: { empty: true, sorted: false, unsorted: true },
        offset: 0,
        pageNumber: 0,
        pageSize: 10,
        paged: true,
        unpaged: false,
      },
      last: false,
      totalPages: 2,
      totalElements: 15,
      size: 10,
      number: 0,
      sort: { empty: true, sorted: false, unsorted: true },
      first: true,
      numberOfElements: 10,
      empty: false,
    }, { status: 200 });
  },
);
